import { useMemberState } from '@/hooks/useMemberState'
import { useCapabilitiesStore } from '@/stores/capabilities'

/**
 * returns whether the corresponding button should be visible and enabled
 * based on the capabilities and the current state
 * - button `visible` if one of the `capabilities` is enabled
 * - button `enabled` if the current state matches the `capability` state
 * i.e. (currently muted and can unmute) or (currently unmute and can mute)
 */
export const useMemberMicrophoneButtonState = (memberId: string) => {
  const memberAudioMuted = useMemberState({
    memberId,
    subscriptionKey: 'audioMuted',
  })
  const memberMicrophoneCapabilityOff = useCapabilitiesStore(
    state => state.memberMicrophoneCapabilityOff,
  )
  const memberMicrophoneCapabilityOn = useCapabilitiesStore(
    state => state.memberMicrophoneCapabilityOn,
  )

  // button visible if one of the capabilities is enabled
  const isMicrophoneButtonVisible =
    memberMicrophoneCapabilityOn || memberMicrophoneCapabilityOff

  // muted and can unmute
  const canUnmute = memberAudioMuted && memberMicrophoneCapabilityOn
  // unmuted and can mute
  const canMute = !memberAudioMuted && memberMicrophoneCapabilityOff

  // check if button can perform the necessary next action
  const isMicrophoneEnabled = canUnmute || canMute

  return {
    isMicrophoneButtonVisible,
    isMicrophoneEnabled,
  }
}
